import { Dispatch } from 'redux';
import BaseAction from 'src/models/common/BaseAction';

interface IncrementCountAction extends BaseAction { type: 'INCREMENT_COUNT'; }
interface DecrementCountAction extends BaseAction { type: 'DECREMENT_COUNT'; }
interface SetCountAction extends BaseAction { type: 'SET_COUNT'; data: number; }
interface AddCountAction extends BaseAction { type: 'ADD_COUNT'; data: number; }

// Declare a 'discriminated union' type. This guarantees that all references to 'type' properties contain one of the
// declared type strings (and not any other arbitrary string).
export type KnownAction = IncrementCountAction | DecrementCountAction | SetCountAction | AddCountAction;

// User helper method
export function updateUserCounter(dispatch: Dispatch<any>, count: number) {
    dispatch(addCounterAction(count));
}

// Private helper method
function addCounterAction(count: number) {
    return {
        type: "ADD_COUNT",
        data: count
    } as AddCountAction;
}




// WEBPACK FOOTER //
// ./src/redux/ExampleActions.ts